// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/purplecard.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/Images/orangecard.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/Images/greencard.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider {
	scroll-snap-type: x mandatory;	
	display: flex;
	-webkit-overflow-scrolling: touch;
	overflow-x: scroll;
    margin-left: 30px;
}

.mob-card{
    height: 45.5vh;
    width: 42.5vh;
    min-height: 342px;
    min-width: 316px;
    margin: 20px;
    scroll-snap-align: start;
    margin-left: 10px;
    
}

.mob-card:nth-child(1){
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size:100% 98%;
    background-repeat: no-repeat;
}
.mob-card:nth-child(2){
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size:100% 98%;
    background-repeat: no-repeat;
}

.mob-card:nth-child(3){
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size:100% 98%;
    background-repeat: no-repeat;
}

.mob-card:nth-child(4){
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size:100% 98%;
    background-repeat: no-repeat;
}
.mob-card:nth-child(5){
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size:100% 98%;
    background-repeat: no-repeat;
}

.mob-card p{
    text-align: left;
    margin: 5px;
    margin-top: 139px;
    margin-right: 10px;
    font-family: 'N27';
    font-style: italic;
    font-weight: 500;
    font-size: 24px;
    line-height: 30px;
    padding: 10px;
}

.question{
    font-family: 'PP-NueBit';
font-style: normal;
/* font-weight: 700; */
font-size: 45px;
line-height: 33px;
text-align: left;
margin: 0;
margin-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/Cards/Cards.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;CAC7B,aAAa;CACb,iCAAiC;CACjC,kBAAkB;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;;AAErB;;AAEA;IACI,mDAAqD;IACrD,wBAAwB;IACxB,4BAA4B;AAChC;AACA;IACI,mDAAqD;IACrD,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,mDAAoD;IACpD,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,mDAAqD;IACrD,wBAAwB;IACxB,4BAA4B;AAChC;AACA;IACI,mDAAqD;IACrD,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B,kBAAkB;AAClB,sBAAsB;AACtB,eAAe;AACf,iBAAiB;AACjB,gBAAgB;AAChB,SAAS;AACT,iBAAiB;AACjB","sourcesContent":[".slider {\n\tscroll-snap-type: x mandatory;\t\n\tdisplay: flex;\n\t-webkit-overflow-scrolling: touch;\n\toverflow-x: scroll;\n    margin-left: 30px;\n}\n\n.mob-card{\n    height: 45.5vh;\n    width: 42.5vh;\n    min-height: 342px;\n    min-width: 316px;\n    margin: 20px;\n    scroll-snap-align: start;\n    margin-left: 10px;\n    \n}\n\n.mob-card:nth-child(1){\n    background: url(\"../../assets/Images/purplecard.svg\");\n    background-size:100% 98%;\n    background-repeat: no-repeat;\n}\n.mob-card:nth-child(2){\n    background: url(\"../../assets/Images/orangecard.svg\");\n    background-size:100% 98%;\n    background-repeat: no-repeat;\n}\n\n.mob-card:nth-child(3){\n    background: url(\"../../assets/Images/greencard.svg\");\n    background-size:100% 98%;\n    background-repeat: no-repeat;\n}\n\n.mob-card:nth-child(4){\n    background: url(\"../../assets/Images/purplecard.svg\");\n    background-size:100% 98%;\n    background-repeat: no-repeat;\n}\n.mob-card:nth-child(5){\n    background: url(\"../../assets/Images/orangecard.svg\");\n    background-size:100% 98%;\n    background-repeat: no-repeat;\n}\n\n.mob-card p{\n    text-align: left;\n    margin: 5px;\n    margin-top: 139px;\n    margin-right: 10px;\n    font-family: 'N27';\n    font-style: italic;\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 30px;\n    padding: 10px;\n}\n\n.question{\n    font-family: 'PP-NueBit';\nfont-style: normal;\n/* font-weight: 700; */\nfont-size: 45px;\nline-height: 33px;\ntext-align: left;\nmargin: 0;\nmargin-left: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
